const createQuery = (possibleWidgets) => `
  widgets {
    ${possibleWidgets.join()}
  }
`
export default createQuery
